// Gallery Models
import { createGalleryStoreDefaultModel } from './gallery/gallery.store'

const galleryContentModels = {
  gallery: createGalleryStoreDefaultModel(),
}

export { galleryContentModels }
